<template>
  <div class="home">
    <el-row :gutter="20">
      <el-col :span="2">
        <div style="margin-top: 1px">
          <el-button
            size="small"
            v-if="Role.updateProgress"
            type="primary"
            @click="AddClick"
            >{{ $t("addproject") }}
          </el-button>
        </div>
      </el-col>
      <el-col :span="2">
        <div style="margin-top: 1px">
          <el-button size="small" type="primary" @click="timelineShowClick">{{
            $t("showtimeline")
          }}</el-button>
        </div>
      </el-col>
      <el-col :span="2">
        <div style="margin-top: 1px">
          <el-button size="small" type="primary" @click="exportClick">{{
            "导出文件"
          }}</el-button>
        </div>
      </el-col>
      <el-col :span="16">
        <vxe-input
          style="width: 600px"
          v-model="filterName"
          type="search"
          clearable
          :placeholder="this.$t('search')"
          @change="searchEvent"
        ></vxe-input>
      </el-col>
    </el-row>
    <vxe-table
      ref="xTable"
      class="mytable-style"
      style="margin: 5px;font-size: 12px;"
      border
      resizable
      height="800"
      :scroll-y="{ enabled: false }"
      :data="searchData"
      :row-config="{ height: 25 }"
      :span-method="mergeRowMethod"
      show-overflow
      align="center"
      :cell-class-name="cellClassName"
    >
      <vxe-column v-if="false" field="id" title="id"></vxe-column>
      <vxe-column
        type="html"
        :filters="[]"
        show-overflow="false"
        width="100"
        field="customerID"
        :title="this.$t('customerID')"
      ></vxe-column>
      <vxe-column
        type="html"
        width="80"
        show-overflow="false"
        field="bikeID"
        :title="this.$t('bikeID')"
      ></vxe-column>
      <vxe-column
        type="html"
        width="80"
        show-overflow="false"
        field="model"
        :title="this.$t('model')"
      ></vxe-column>
      <vxe-column
        type="html"
        width="150"
        show-overflow="false"
        field="project"
        :title="this.$t('projectName')"
      >
      </vxe-column>
      <vxe-column
        type="html"
        show-overflow="false"
        width="300"
        field="project_Desription"
        :title="this.$t('projectdescription')"
        align="left"
      ></vxe-column>
      <vxe-column
        show-overflow="false"
        type="html"
        width="%8"
        field="head"
        :title="this.$t('RDLEADER')"
      ></vxe-column>
      <vxe-column
        show-overflow="false"
        type="html"
        width="%8"
        field="busHead"
        :title="this.$t('BUSINESSLEADER')"
      ></vxe-column>
      <vxe-column
        align="left"
        width="120"
        field="step.stepName"
        type="html"
        :title="this.$t('step')"
      >
        <template #default="{ row }">
          <span v-if="row.step.stepName !== 'AddStep'">{{ row.step.stepName }}</span>
          <span
            @click="AddNewStepClick(row)"
            style="
              font-size: 10px;
              margin: 0px auto;
              display: block;
              color: rgb(48, 113, 185);
              cursor: pointer;
              width: max-content;
            "
            v-if="
              row.step.stepName === 'AddStep' &&
              this.Role.updateProgress &&
              row.status === '进行中'
            "
          >
            点击添加阶段
          </span>
        </template>
      </vxe-column>
      <vxe-column
        type="html"
        width="105"
        field="step.planTime"
        :title="this.$t('startTime')"
      >
        <template #default="{ row }">
          <span v-if="row.step.startTime">{{
            new Date(row.step.startTime).Format("yyyy-MM-dd")
          }}</span>
        </template>
      </vxe-column>
      <vxe-column
        type="html"
        width="105"
        field="step.planTime"
        :title="this.$t('planendtime')"
      >
        <template #default="{ row }">
          <span v-if="row.step.planTime">{{
            new Date(row.step.planTime).Format("yyyy-MM-dd")
          }}</span>
        </template>
      </vxe-column>
      <vxe-column
        type="html"
        width="105"
        field="step.actTime"
        :title="this.$t('actendtime')"
      >
        <template #default="{ row }">
          <span v-if="row.step.actTime">{{
            new Date(row.step.actTime).Format("yyyy-MM-dd")
          }}</span>
        </template>
      </vxe-column>
      <vxe-column type="html" width="90" :title="this.$t('progress')">
        <template #default="{ row }">
          <div v-html="isDelay(row.step)"></div>
        </template>
      </vxe-column>
      <vxe-column width="90" field="changeProcess" :title="this.$t('progressinfo')">
        <template #default="{ row }">
          <a
            style="color: #3071b9; cursor: pointer; font-size: 8px"
            v-on:click="changeProcess(row)"
            >{{ this.$t("vieworinput") }}</a
          >
        </template>
      </vxe-column>
      <vxe-column
        align="left"
        show-overflow="false"
        field="remark"
        :title="this.$t('remark')"
        type="html"
      ></vxe-column>
      <vxe-column
        align="left"
        field="status"
        :title="this.$t('status')"
        type="html"
        width="80"
        :filters="[
          { label: '进行中', value: '进行中' },
          { label: '已结案', value: '已结案' },
          { label: '已关闭', value: '关闭' },
        ]"
        :filter-multiple="false"
      >
      </vxe-column>
      <vxe-column field="operate" title="关联产品" width="50" show-overflow>
        <template #default="{ row }">
          <vxe-button
            style="corsur: pointer"
            type="text"
            class="fa fa-search"
            @click="productspreviewclick(row)"
          >
          </vxe-button>
        </template>
      </vxe-column>
      <vxe-column field="operate" title="图片备注" width="50" show-overflow>
        <template #default="{ row }">
          <vxe-button
            style="corsur: pointer"
            type="text"
            class="fa fa-search"
            @click="imgViewClick(row)"
          >
          </vxe-button>
        </template>
      </vxe-column>
      <vxe-column
        v-if="Role.updateProgress"
        field="operate"
        :title="this.$t('operate')"
        width="50"
        show-overflow
      >
        <template #default="{ row }">
          <vxe-button
            v-if="!(row.status == '已结案' || row.status == '关闭')"
            type="text"
            icon="fa fa-edit"
            @click="Edit(row)"
          ></vxe-button>
        </template>
      </vxe-column>
    </vxe-table>
  </div>

  <el-dialog :close-on-click-modal="false" :fullscreen="true" v-model="dialogShow">
    <div>
      <div><strong>请选择项目类别:</strong></div>
      <div @click="MenuClick('定制化配件')" class="menuDiv">
        <span style="line-height: 80px; font-size: 18px">定制化配件</span>
      </div>
      <div @click="MenuClick('定制程序')" class="menuDiv">
        <span style="line-height: 80px; font-size: 18px">定制程序</span>
      </div>
      <div @click="MenuClick('B类协议联调')" class="menuDiv">
        <span style="line-height: 80px; font-size: 18px">B类协议联调</span>
      </div>
    </div>
  </el-dialog>

  <el-dialog :close-on-click-modal="false" :fullscreen="true" v-model="AddDialogShow2">
    <div style="padding: 10px; margin: 0 auto; width: 800px; background-color: #e9ecef">
      <div style="margin-bottom: 20px">
        <strong style="font-size: 18px">新增项目</strong>
      </div>
      <el-row>
        <el-col :span="2">
          <span style="line-height: 35px">客户编号</span>
        </el-col>
        <el-col :span="8">
          <el-autocomplete
            class="inline-input w-100"
            autosize
            :fetch-suggestions="CustomerIDSearch"
            v-model="FormData.CustomerID"
            placeholder="请输入客户编号"
          ></el-autocomplete>
        </el-col>

        <el-col :offset="3" :span="2">
          <span style="line-height: 35px">车款编号</span>
        </el-col>
        <el-col :span="8">
          <el-autocomplete
            class="inline-input w-100"
            autosize
            :fetch-suggestions="BikeIDSearch"
            v-model="FormData.BikeID"
            placeholder="请输入车款编号"
          ></el-autocomplete>
        </el-col>
      </el-row>
      <br />
      <el-row>
        <el-col :span="2">
          <span style="line-height: 35px">电机型号</span>
        </el-col>
        <el-col :span="8">
          <el-autocomplete
            class="inline-input w-100"
            autosize
            :fetch-suggestions="ModelSearch"
            v-model="FormData.Model"
            placeholder="请输入电机型号"
          ></el-autocomplete>
        </el-col>

        <el-col :offset="3" :span="2">
          <span style="line-height: 35px; font-size: 10px">研发负责人</span>
        </el-col>
        <el-col :span="8">
          <el-autocomplete
            class="inline-input w-100"
            autosize
            v-model="FormData.Head"
            :fetch-suggestions="HeadSearch"
            placeholder="请输入研发负责人名称"
          ></el-autocomplete>
        </el-col>
      </el-row>

      <br />

      <el-row>
        <el-col :span="2">
          <span style="line-height: 35px">关注人</span>
        </el-col>
        <el-col :span="8">
          <el-autocomplete
            class="inline-input w-100"
            autosize
            v-model="FormData.Follower"
            :fetch-suggestions="HeadSearch"
            placeholder="请输入关注人名称"
          ></el-autocomplete>
        </el-col>
        <el-col :offset="3" :span="2">
          <span style="line-height: 35px">确认人</span>
        </el-col>
        <el-col :span="8">
          <el-autocomplete
            class="inline-input w-100"
            v-model="FormData.Confirmer"
            :fetch-suggestions="HeadSearch"
            placeholder="请输入确认人名称"
          ></el-autocomplete>
        </el-col>
      </el-row>

      <br />

      <el-row>
        <el-col :span="2">
          <span style="line-height: 35px">项目名称</span>
        </el-col>
        <el-col :span="21">
          <el-autocomplete
            class="inline-input w-100"
            autosize
            :fetch-suggestions="ProjectNameSearch"
            v-model="FormData.Project"
            placeholder="请输入开发项目名称"
          ></el-autocomplete>
        </el-col>
      </el-row>

      <br />

      <el-row>
        <el-col :span="2">
          <span style="line-height: 30px">项目描述</span>
        </el-col>
        <el-col :span="21">
          <el-input
            v-model="FormData.Project_Desription"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 10 }"
            placeholder="请输入项目备注"
          >
          </el-input>
        </el-col>
      </el-row>

      <br />

      <el-row>
        <el-col :span="2">
          <span style="line-height: 30px">项目备注</span>
        </el-col>
        <el-col :span="21">
          <el-input
            v-model="FormData.Remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 10 }"
            placeholder="请输入项目备注"
          >
          </el-input>
        </el-col>
      </el-row>

      <br />

      <el-row>
        <el-col :span="2">
          <span style="line-height: 40px">项目状态</span>
        </el-col>
        <el-col :span="7">
          <el-select
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 10 }"
            v-model="FormData.Status"
          >
            <el-option value="进行中"></el-option>
            <el-option value="已结案"></el-option>
            <el-option value="关闭"></el-option>
          </el-select>
        </el-col>
        <el-col :offset="3" :span="2">
          <span style="line-height: 35px; font-size: 10px">业务负责人</span>
        </el-col>
        <el-col :span="8">
          <el-autocomplete
            class="inline-input w-100"
            v-model="FormData.BusHead"
            :fetch-suggestions="HeadSearch"
            placeholder="请输入业务负责人名称"
          ></el-autocomplete>
        </el-col>
      </el-row>
      <br />
      <hr />

      <div style="margin-top: 20px; text-align: left">关联产品：</div>

      <el-row>
        <el-col>
          <table
            style="margin-top: 10px; background-color: white; border: #e3e6f0 solid 2px"
          >
            <tr style="height: 30px">
              <th style="width: 430px">关联产品</th>
              <th style="width: 350px">操作</th>
            </tr>
            <tr v-for="item in FormData.ProductRef" :key="item" style="height: 40px">
              <td>{{ item }}</td>
              <td>
                <button
                  @click="productpreviewclick(item)"
                  style="
                    background-color: transparent;
                    border-color: transparent;
                    color: #3071b9;
                  "
                >
                  预览
                </button>
                <button
                  @click="removeproductRef(item)"
                  style="
                    background-color: transparent;
                    border-color: transparent;
                    color: #3071b9;
                  "
                >
                  删除
                </button>
              </td>
            </tr>
            <td style="padding: 15px" colspan="2">
              <a @click="addproductref" style="color: #3071b9; cursor: pointer"
                >点击增加产品</a
              >
            </td>
          </table>
        </el-col>
      </el-row>

      <div style="margin-top: 20px; text-align: left">图片备注：</div>

      <el-row>
        <el-col>
          <table
            style="margin-top: 10px; background-color: white; border: #e3e6f0 solid 2px"
          >
            <tr style="height: 30px">
              <th style="width: 430px">图片备注</th>
              <th style="width: 350px">操作</th>
            </tr>
            <tr v-for="item in FormData.Pictures" :key="item" style="height: 40px">
              <td>{{ item.FileName }}</td>
              <td>
                <button
                  @click="
                    $alert(
                      '<img style=\'max-width:300px;display: block;margin:0 auto\' src=\'' +
                        item.FileUrl +
                        '\'/>',
                      '',
                      {
                        dangerouslyUseHTMLString: true,
                      }
                    )
                  "
                  style="
                    background-color: transparent;
                    border-color: transparent;
                    color: #3071b9;
                  "
                >
                  预览
                </button>
                <button
                  @click="
                    FormData.Pictures = this.FormData.Pictures.filter((i) => i != item)
                  "
                  style="
                    background-color: transparent;
                    border-color: transparent;
                    color: #3071b9;
                  "
                >
                  删除
                </button>
              </td>
            </tr>
            <td style="padding: 15px" colspan="2">
              <el-upload
                :show-file-list="false"
                :action="null"
                :http-request="UploadPicture"
              >
                <button
                  style="
                    background-color: transparent;
                    border-color: transparent;
                    color: #3071b9;
                  "
                >
                  点击上传文件
                </button>
              </el-upload>
            </td>
          </table>
        </el-col>
      </el-row>

      <br />
      <el-row></el-row>
      <el-row :gutter="10">
        <el-col :span="9"></el-col>
        <el-col v-if="isEdit" :span="4">
          <el-button @click="deleteProjectClick" type="danger">删除</el-button>
        </el-col>
        <el-col :span="3">
          <el-button @click="confirm" type="primary">确定</el-button>
        </el-col>
        <el-col :span="3">
          <el-button @click="cancelClick">取消</el-button>
        </el-col>
      </el-row>
    </div>
  </el-dialog>

  <el-dialog
    :close-on-click-modal="false"
    :fullscreen="true"
    v-model="ChangeProcessDialog"
  >
    <div style="padding: 10px; margin: 0 auto; width: 800px; background-color: #e9ecef">
      <div style="margin-bottom: 20px">
        <strong style="font-size: 18px">{{ StepItem.step.stepName }}</strong>
      </div>
      <br />
      <el-row>
        <el-col :offset="0" :span="3">
          <strong style="line-height: 35px">项目开始时间</strong>
        </el-col>
        <el-col :span="6">
          <el-date-picker
            type="date"
            :autosize="{ minRows: 2, maxRows: 10 }"
            v-model="StepItem.step.startTime"
            placeholder="未完成"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <br />
      <el-row>
        <el-col :span="3">
          <strong style="line-height: 35px">计划完成时间</strong>
        </el-col>
        <el-col :span="6">
          <el-date-picker
            type="date"
            :autosize="{ minRows: 2, maxRows: 10 }"
            v-model="StepItem.step.planTime"
            placeholder="未完成"
          >
          </el-date-picker>
        </el-col>

        <el-col :offset="3" :span="3">
          <strong style="line-height: 35px">实际完成时间</strong>
        </el-col>
        <el-col :span="6">
          <el-date-picker
            type="date"
            :autosize="{ minRows: 2, maxRows: 10 }"
            v-model="StepItem.step.actTime"
            placeholder="未完成"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <br />

      <br />

      <el-row>
        <el-col :span="2">
          <strong>项目状态</strong>
        </el-col>

        <el-col :offset="1" :span="3">
          <span
            style="font-size: large; line-height: 20px; text-align: center"
            v-html="isDelay(StepItem.step)"
          ></span>
        </el-col>
      </el-row>

      <el-row style="margin-bottom: 30px; margin-top: 20px" v-if="StepItem.step.isDelay">
        <el-col :span="2">
          <strong style="line-height: 30px">逾期原因</strong>
        </el-col>
        <el-col :offset="1" :span="19">
          <el-input
            v-model="StepItem.step.delayReason"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 10 }"
            placeholder="请输入逾期原因"
          >
          </el-input>
        </el-col>
      </el-row>

      <el-row v-if="StepItem.step.isDelay">
        <el-col :span="2">
          <strong style="line-height: 30px">逾期措施</strong>
        </el-col>
        <el-col :offset="1" :span="19">
          <el-input
            v-model="StepItem.step.delayMeasure"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 10 }"
            placeholder="请输入逾期措施"
          >
          </el-input>
        </el-col>
      </el-row>

      <br />
      <br />

      <el-row>
        <el-col :span="2">
          <strong style="line-height: 30px">附件</strong>
        </el-col>
        <el-col :offset="1" :span="19">
          <table
            style="margin-top: 20px; background-color: white; border: #e3e6f0 solid 2px"
          >
            <tr style="height: 30px">
              <th style="width: 300px">文件名</th>
              <th style="width: 300px">操作</th>
            </tr>
            <tr
              style="height: 40px"
              :key="index"
              v-for="(item, index) in StepItem.step.attchments"
            >
              <td>{{ item.fileName }}</td>
              <td>
                <button
                  @click="previewClick(item)"
                  style="
                    background-color: transparent;
                    border-color: transparent;
                    color: #3071b9;
                  "
                >
                  下载
                </button>
                <button
                  v-show="
                    Role.updateProgress &&
                    !(StepItem.status == '已结案' || StepItem.status == '关闭')
                  "
                  @click="deleteClick(item)"
                  style="
                    background-color: transparent;
                    border-color: transparent;
                    color: #3071b9;
                  "
                >
                  删除
                </button>
              </td>
            </tr>
            <td style="padding: 15px" v-if="!StepItem.step.attchments.length" colspan="2">
              暂无文件
            </td>
          </table>
        </el-col>
      </el-row>
      <el-upload
        v-show="
          Role.updateProgress &&
          !(StepItem.status == '已结案' || StepItem.status == '关闭')
        "
        :show-file-list="false"
        :action="null"
        :http-request="UploadData"
      >
        <button
          style="background-color: transparent; border-color: transparent; color: #3071b9"
        >
          点击上传文件
        </button>
      </el-upload>
      <br />
      <br />

      <el-row :gutter="10">
        <el-col v-show="Role.updateProgress" :span="16">
          <!-- <el-button v-if="StepItem.projectType != '定制化配件'" @click="AddNewStepClick(StepItem)" type="primary">增加新一轮测试
          </el-button> -->
        </el-col>

        <el-col
          v-show="
            Role.updateProgress &&
            !(StepItem.status == '已结案' || StepItem.status == '关闭')
          "
          :span="2"
        >
          <el-button @click="confirmUpdateStep(StepItem)" type="primary">确定</el-button>
        </el-col>
        <el-col :span="4">
          <el-button @click="ChangeProcessDialog = false">返回</el-button>
        </el-col>
      </el-row>
    </div>
  </el-dialog>

  <div>
    <el-dialog :close-on-click-modal="false" :fullscreen="true" v-model="timelineShow">
      <el-button @click="timelineShowClick(true)">{{
        showAllYearData ? "显示全年数据" : "显示当月数据"
      }}</el-button>
      <div id="chartcontainer"></div>
    </el-dialog>
  </div>

  <div>
    <el-dialog :close-on-click-modal="false" :fullscreen="false" v-model="selectModel">
      <el-row>
        <el-col :span="2">
          <span style="line-height: 35px">产品型号</span>
        </el-col>
        <el-col :span="21">
          <el-autocomplete
            class="inline-input w-100"
            autosize
            :fetch-suggestions="ProductModelSearch"
            v-model="ModelSelect"
            placeholder="请输入产品型号"
          ></el-autocomplete>
        </el-col>
      </el-row>
      <br />
      <el-row>
        <el-col :span="9"></el-col>
        <el-col :span="3">
          <el-button @click="ModelSelectConfirm()" type="primary">确定</el-button>
        </el-col>
        <el-col :span="3">
          <el-button @click="selectModel = false">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>

  <el-dialog :width="1400" v-model="previewShow">
    <div
      id="dataTable"
      class="table-responsive table mt-2"
      role="grid"
      aria-describedby="dataTable_info"
      style="overflow-y: hidden"
    >
      <table id="dataTable" class="table my-0">
        <thead>
          <tr>
            <th style="width: 63px">序号</th>
            <th><span>型号</span></th>
            <th style="width: 50px">图片</th>
            <th>状态</th>
            <!-- <th>规格</th> -->
            <th style="max-width: 500px">产品简介</th>
            <th style="max-width: 200px">备注</th>
            <!--                <th>标准报价</th>-->
            <!--                <th>成本价格</th>-->
            <th>客户编号</th>
            <th>车款编号</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="previewData in previewDatas" :key="previewData" style="height: 1px">
            <td>1</td>
            <td>{{ previewData.model }}</td>
            <td style="text-align: center">
              <img :src="previewData.picture" style="height: 100px; cursor: pointer" />
            </td>
            <td>{{ previewData.status }}</td>
            <td>
              <div style="max-width: 600px" v-html="previewData.description" />
            </td>
            <td style="max-width: 300px; white-space: pre-wrap; text-align: left">
              {{ previewData.remark }}
            </td>

            <td style="height: inherit; padding: 0">
              <div style="height: 100%; display: flex; flex-direction: column">
                <div
                  style="
                    flex: 1;
                    display: table;
                    margin-bottom: -1px;
                    border-bottom: 1px solid #e3e6f0;
                  "
                  :key="strs"
                  v-for="strs in splitStr(previewData.customerID)"
                >
                  <div style="display: table-cell; vertical-align: middle">
                    {{ strs }}
                  </div>
                </div>
              </div>
            </td>
            <td style="height: inherit; padding: 0">
              <div style="height: 100%; display: flex; flex-direction: column">
                <div
                  style="
                    flex: 1;
                    display: table;
                    margin-bottom: -1px;
                    border-bottom: 1px solid #e3e6f0;
                  "
                  :key="strs"
                  v-for="strs in splitStr(previewData.bikeID)"
                >
                  <div style="display: table-cell; vertical-align: middle">
                    {{ strs }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </el-dialog>
</template>

<script>
import Swal from "sweetalert2";
import {
  AddProgressItem,
  GetProgressList,
  GetUser,
  UpdateProgressItem,
  UpdateStepItem,
  AddNewStep,
  DeleteProgress,
  GetProductByid,
  GetAllProductModels,
} from "../common/httphelper";
import XEUtils, { map, random, set } from "xe-utils";
import getRole from "../common/role";
import upload from "element-plus/es/components/upload/src/ajax";
import ApexCharts from "apexcharts";
import moment from "moment";
import { VxeTableInstance } from "vxe-table";
import { ref } from "vue";
import { emitWarning } from "process";
import { delay } from "q";
// @ is an alias to /src

const dayjs = require("dayjs");
dayjs.locale({ weekStart: 1 });
var weekOfYear = require("dayjs/plugin/weekOfYear");
dayjs.extend(weekOfYear);

const OSS = require("ali-oss");

const client = new OSS({
  // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
  region: "oss-cn-guangzhou",
  // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
  accessKeyId: "LTAItdKUSj0MOUTc",
  accessKeySecret: "LhqjeZY9lC4rpAStCEMAIir7v6kFhp",
  // 刷新临时访问凭证的时间间隔，单位为毫秒。
  refreshSTSTokenInterval: 300000,
  // 填写Bucket名称。
  bucket: "motinova-admin",
});

// 对Date的扩展，将 Date 转化为指定格式的String
// 例子：
// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
Date.prototype.Format = function (fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "H+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

/**
 * @param {Object} json
 * @param {Object} type： 默认不传 ==>全部小写;传1 ==>全部大写;传2 ==>首字母大写
 * 将json的key值进行大小写转换
 */
function jsonKeysToCase(json, type) {
  if (typeof json == "object") {
    var tempJson = JSON.parse(JSON.stringify(json));
    toCase(tempJson);
    return tempJson;
  } else {
    return json;
  }

  //对象字母转换
  function toCase(json) {
    if (typeof json == "object") {
      if (Array.isArray(json)) {
        json.forEach(function (item) {
          toCase(item);
        });
      } else {
        for (var key in json) {
          var item = json[key];
          if (typeof item == "object") {
            toCase(item);
          }
          delete json[key];
          switch (type) {
            case 1:
              //key值全部大写
              json[key.toLocaleUpperCase()] = item;
              break;
            case 2:
              //key值首字母大写，其余小写
              json[key.substring(0, 1).toLocaleUpperCase() + key.substring(1)] = item;
              break;
            default:
              //默认key值全部小写
              json[key.toLocaleLowerCase()] = item;
              break;
          }
        }
      }
    }
  }
}

export default {
  data() {
    return {
      FormData: this.FormDataObj(),
      dialogShow: false,
      tableData3: [],
      searchData: [],
      filterName: "",
      isEdit: false,
      Role: {},
      AddDialogShow2: false,
      Users: [],
      ChangeProcessDialog: false,
      StepItem: {},
      timelineShow: false,
      selectModel: false,
      RawData: [],
      AllProductModels: [],
      ModelSelect: "",
      previewShow: false,
      previewDatas: [],
      showAllYearData: false,
    };
  },
  methods: {
    //筛选
    filterCustomerID() {
      let fuck = this.tableData3.map((item) => item.customerID);

      fuck = Array.from(new Set(fuck));

      let data = [];
      data = fuck.map((item) => {
        return {
          label: item,
          value: item,
        };
      });

      const xTable = this.$refs.xTable;
      const $table = xTable;
      const column = $table.getColumnByField("customerID");
      if (column) {
        // 修改筛选列表，并默认设置为选中状态
        $table.setFilter(column, data);
        // 修改条件之后，需要手动调用 updateData 处理表格数据
        $table.updateData();
      }
    },

    //预览
    previewClick(item) {
      window.open(item.fileUrl, "_blank");
    },

    //上传附件到阿里云
    async UploadData(file) {
      try {
        Swal.fire({
          title: "上传中...",
          html: "请稍候...",
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
        Swal.showLoading();
        // object表示上传到OSS的文件名称。
        // file表示浏览器中需要上传的文件，支持HTML5 file和Blob类型。
        const r1 = await client.put(
          "ProductManagerProcess/" +
            Math.random().toString(36).substr(2) +
            file.file.name,
          file.file
        );
        Swal.close();
        if (r1.url === null) {
          return;
        }
        const { value: uploadFileName } = await Swal.fire({
          title: "请输入文件名",
          input: "text",
          inputPlaceholder: "请输入文件名",
          allowOutsideClick: false,
          showCloseButton: false,
        });

        if (uploadFileName) {
          this.StepItem.step.attchments.push({
            fileName: uploadFileName,
            fileUrl: r1.url,
          });
        }

        this.uploadShow = true;
      } catch (e) {
        console.error("error: %j", e);
      }
      this.refreshList();
    },

    //删除文件
    deleteClick(item) {
      this.StepItem.step.attchments = this.StepItem.step.attchments.filter(
        (x) => x.fileUrl !== item.fileUrl
      );
    },

    ///是否延期
    isDelay(row) {
      row.isDelay = false;

      if (!row.planTime) {
        return "<div style='background:#e9ecef;color:black'>" + "未计划" + "<div/>";
      }

      if (row.status == "关闭") {
        return "<div style='background:#e9ecef;color:black'>" + "已关闭" + "<div/>";
      }

      var endDate = new Date(new Date(new Date().toDateString()).getTime()); //今天的23时59分59秒
      if (!row.actTime && new Date(row.planTime) < endDate) {
        row.isDelay = true;
        return '<div style="background:#f03e3e;color:white">已逾期<div/>'; //无实际截止时间且计划完成时间小于今天
      }
      if (row.actTime && new Date(row.actTime) > new Date(row.planTime)) {
        row.isDelay = true;
        return '<div style="background:#0ca678;color:white">' + "逾期完成" + "<div/>";
      }
      return row.actTime
        ? "<div style='background:#10dea0;color:white'>" + `已完成` + "<div/>"
        : "进行中";
    },

    Export() {
      this.$refs.xTable.exportData({ type: "html" });
    },

    //菜单点击
    MenuClick(menustr) {
      this.FormData.ProjectType = menustr;
      this.AddDialogShow2 = true;
    },

    ///添加项目
    AddClick() {
      this.isEdit = false;
      this.FormData = this.FormDataObj();
      this.AddDialogShow2 = true;
    },

    ///编辑行
    Edit(row) {
      this.isEdit = true;
      let items = this.tableData3.filter((item) => {
        return item.id == row.id;
      });

      this.FormData = jsonKeysToCase(items[0], 2);

      this.FormData.Steps = this.FormData.Steps.filter(
        (item) => item.StepName != "AddStep"
      );

      this.AddDialogShow2 = true;
    },

    //修改进度
    changeProcess(row) {
      this.ChangeProcessDialog = true;
      this.StepItem = JSON.parse(JSON.stringify(row));
    },

    //新增阶段
    async AddNewStepClick(row) {
      const { value: stepName } = await Swal.fire({
        title: "请输入阶段名称",
        input: "text",
        inputPlaceholder: "请输入名称",
        allowOutsideClick: false,
        showCloseButton: true,
      });

      if (!stepName) {
        return;
      }

      AddNewStep(row.id, stepName).then(async (res) => {
        if (res.data.data) {
          this.ChangeProcessDialog = false;
          this.refresh();
          await Swal.fire({
            icon: "success",
            title: "新增成功",
            showConfirmButton: false,
            timer: 3000,
          });
        } else {
        }
      });
    },

    confirmUpdateStep(item) {
      UpdateStepItem(item.id, item.step).then((res) => {
        if (res.data.data) {
          this.ChangeProcessDialog = false;
          this.refresh();
        }
      });
    },

    //智能提示
    CustomerIDSearch(query, cb) {
      let mymap = new Map();
      this.tableData3.forEach((item) => mymap.set(item.customerID));
      let res = Array.from(mymap.keys());
      if (query)
        res = res.filter((item) => item.toLowerCase().indexOf(query.toLowerCase()) == 0);
      cb(
        res.map((item) => {
          return { value: item };
        })
      );
    },
    //智能提示
    ModelSearch(query, cb) {
      let mymap = new Map();
      this.tableData3
        .filter((item) => item.bikeID == this.FormData.BikeID)
        .forEach((item) => mymap.set(item.model));
      let res = Array.from(mymap.keys());
      if (query)
        res = res.filter((item) => item.toLowerCase().indexOf(query.toLowerCase()) == 0);
      cb(
        res.map((item) => {
          return { value: item };
        })
      );
    },
    //智能提示
    BikeIDSearch(query, cb) {
      let mymap = new Map();
      this.tableData3.forEach((item) => mymap.set(item.bikeID));
      let res = Array.from(mymap.keys());
      if (query)
        res = res.filter((item) => item.toLowerCase().indexOf(query.toLowerCase()) == 0);
      cb(
        res.map((item) => {
          return { value: item };
        })
      );
    },
    HeadSearch(query, cb) {
      let mymap = new Map();
      this.Users.forEach((item) => mymap.set(item.realName));
      let res = Array.from(mymap.keys());
      if (query)
        res = res.filter((item) => item.toLowerCase().indexOf(query.toLowerCase()) == 0);
      cb(
        res.map((item) => {
          return { value: item };
        })
      );
    },
    ProjectNameSearch(query, cb) {
      let mymap = new Map();
      this.tableData3.forEach((item) => mymap.set(item.project));
      let res = Array.from(mymap.keys());
      if (query)
        res = res.filter((item) => item.toLowerCase().indexOf(query.toLowerCase()) == 0);
      cb(
        res.map((item) => {
          return { value: item };
        })
      );
    },
    ProductModelSearch(query, cb) {
      let mymap = new Map();
      this.AllProductModels.forEach((item) => mymap.set(item.item));

      let res = Array.from(mymap.keys());

      if (query)
        res = res.filter((item) => item.toLowerCase().indexOf(query.toLowerCase()) == 0);
      cb(
        res.map((item) => {
          return { value: item };
        })
      );
    },

    //确认选择型号
    ModelSelectConfirm() {
      //console.log(this.FormData)
      this.FormData.ProductRef.push(this.ModelSelect);
      this.ModelSelect = "";
      this.selectModel = false;
    },

    //合并单元格方法
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      let currentrowspan = row["steps"].length;

      const mergeIdCol = [
        "busHead",
        "head",
        "remark",
        "project_Desription",
        "operate",
        "results",
        "status",
      ];
      const cellValue = row[column.property];
      const prevRow = visibleData[_rowIndex - 1];
      let nextRow = visibleData[_rowIndex + 1];

      if (mergeIdCol.includes(column.property)) {
        if (prevRow && prevRow["id"] === row["id"]) {
          return { rowspan: 0, colspan: 0 };
        } else {
          return { rowspan: currentrowspan, colspan: 1 };
        }
      }

      if (cellValue && column.property === "customerID") {
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 };
        } else {
          let countRowspan = 1;
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex];
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 };
          }
        }
      }

      if (cellValue && column.property === "bikeID") {
        if (
          prevRow &&
          prevRow[column.property] === cellValue &&
          prevRow["customerID"] === row["customerID"]
        ) {
          return { rowspan: 0, colspan: 0 };
        } else {
          let countRowspan = 1;
          while (
            nextRow &&
            nextRow[column.property] === cellValue &&
            nextRow["customerID"] === row["customerID"]
          ) {
            nextRow = visibleData[++countRowspan + _rowIndex];
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 };
          }
        }
      }

      if ((cellValue && column.property === "model") || column.property == "project") {
        if (
          prevRow &&
          prevRow[column.property] === cellValue &&
          prevRow["bikeID"] === row["bikeID"] &&
          prevRow["customerID"] === row["customerID"]
        ) {
          return { rowspan: 0, colspan: 0 };
        } else {
          let countRowspan = 1;
          while (
            nextRow &&
            nextRow[column.property] === cellValue &&
            nextRow["bikeID"] === row["bikeID"] &&
            nextRow["customerID"] === row["customerID"]
          ) {
            nextRow = visibleData[++countRowspan + _rowIndex];
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 };
          }
        }
      }

      if (
        currentrowspan > 1 &&
        row.step.stepName === "AddStep" &&
        !(this.Role.updateProgress || row.step.status === "进行中")
      ) {
        return { rowspan: 0, colspan: 0 };
      }

      if (currentrowspan <= 1 && row.step.stepName === "AddStep") {
        let disApperenceColumn = [
          "step.planTime",
          "step.actTime",
          "changeProcess",
          undefined,
        ];
        if (disApperenceColumn.includes(column.property)) {
          return { rowspan: 0, colspan: 0 };
        } else {
          if (column.property == "step.stepName") {
            return { rowspan: 1, colspan: 6 };
          } else return { rowspan: 1, colspan: 1 };
        }
      }

      if (row.step.stepName == "AddStep") {
        if (column.property == "step.stepName") {
          return { rowspan: 1, colspan: 6 };
        } else {
          return { rowspan: 0, colspan: 0 };
        }
      }
    },

    //新建提交确认
    async confirm() {
      if (!this.FormData.CustomerID) {
        Swal.fire("客户编号不能为空");
        return;
      }
      if (!this.FormData.BikeID) {
        Swal.fire("车款编号不能为空");
        return;
      }

      if (!this.FormData.Model) {
        Swal.fire("电机型号不能为空");
        return;
      }

      if (!this.FormData.Project) {
        Swal.fire("开发项目不能为空");
        return;
      }

      if (!this.FormData.Head) {
        Swal.fire("负责人不能为空");
        return;
      }

      if (this.FormData.Status === "关闭" || this.FormData.Status === "已结案") {
        let confirmCloseProj = false;
        await Swal.fire({
          title: "确定操作吗?",
          text: "项目状态更改为'已结案'或'关闭'将无法再进行修改!",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }).then((res) => {
          confirmCloseProj = res.isConfirmed;
        });
        if (!confirmCloseProj) return;
      }

      if (!this.isEdit) {
        await AddProgressItem(this.FormData).then(async (res) => {
          if (res.data.data) {
            this.dialogShow = false;
            this.AddDialogShow2 = false;
            this.refresh();
            Swal.fire("已创建流程");
          } else {
            Swal.fire({
              icon: "warning",
              title: res.data.message,
              showConfirmButton: false,
              timer: 3000,
            });
          }
        });
      } else {
        await UpdateProgressItem(this.FormData).then(async (res) => {
          if (res.data.data) {
            this.AddDialogShow2 = false;
            this.refresh();
            Swal.fire("已创建流程");
          } else {
            Swal.fire({
              icon: "warning",
              title: res.data.message,
              showConfirmButton: false,
              timer: 3000,
            });
          }
        });
      }
    },

    //根据内容改变颜色
    cellClassName({ row, rowIndex, column, columnIndex }) {
      if (column.property === "status") {
        if (row.status === "关闭") {
          return "col-gray";
        }
        if (row.status === "已结案") {
          return "col-green";
        }
      }
    },

    ///取消窗口
    cancelClick() {
      this.dialogShow = false;
      this.AddDialogShow2 = false;
      this.FormData = this.FormDataObj();
    },

    ///刷新数据
    async refresh() {
      await GetProgressList().then((res) => {
        let data = [];

        this.RawData = JSON.parse(JSON.stringify(res.data));

        res.data.forEach((item) => {
          // if (!item.steps.length) {
          //   item.steps.push(
          //     { stepName: 'AddStep' }
          //   )
          // } else {

          //   let addStep = JSON.parse(JSON.stringify(item.steps[0]))

          //   //增加按钮  增加阶段的
          //   addStep.stepName = 'AddStep'
          //   if (this.Role.updateProgress) {
          //     item.steps.push(
          //       addStep
          //     )
          //   }
          // }

          // if (this.Role.updateProgress && item.status == "进行中") {
          item.steps.push({ stepName: "AddStep" });
          // }

          item.steps.forEach((step) => {
            let newItem = JSON.parse(JSON.stringify(item));
            newItem.step = step;
            data.push(newItem);
          });
        });

        this.tableData3 = data;
      });
      this.searchEvent();
      this.filterCustomerID();
    },

    //全表搜索
    searchEvent() {
      const filterName = XEUtils.toValueString(this.filterName).trim().toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = [
          "customerID",
          "bikeID",
          "model",
          "devProcess",
          "remark",
          "project",
          "project_Desription",
          "head",
          "status",
          "results",
        ];
        const rest = this.tableData3.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key]).toLowerCase().indexOf(filterName) > -1
          )
        );
        this.searchData = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `<span class="keyword-lighten">${match}</span>`
            );
          });
          return item;
        });
      } else {
        this.searchData = this.tableData3;
      }
    },

    deleteProjectClick() {
      DeleteProgress(this.FormData.Id).then((res) => {
        if (res.data) {
          Swal.fire({
            icon: "success",
            title: "已创建流程",
            showConfirmButton: false,
            timer: 3000,
          });
          this.AddDialogShow2 = false;
          this.refresh();
        } else {
          Swal.fire({
            icon: "warning",
            title: "该条目存在未审批的流程",
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
    },

    //显示时间线备份
    async timelineShowClickBak() {
      this.timelineShow = true;
      await this.refresh();
      let containerElement = document.querySelector("#chartcontainer");
      if (containerElement) {
        containerElement.innerHTML = '<div id="chart"></div>';
      }

      let options = {
        series: [],
        chart: {
          height: 800,
          type: "rangeBar",
          locales: [
            {
              name: "en",
              options: {
                months: [
                  "1月",
                  "2月",
                  "3月",
                  "4月",
                  "5月",
                  "6月",
                  "7月",
                  "8月",
                  "9月",
                  "10月",
                  "11月",
                  "12月",
                ],
                shortMonths: [
                  "1月",
                  "2月",
                  "3月",
                  "4月",
                  "5月",
                  "6月",
                  "7月",
                  "8月",
                  "9月",
                  "10月",
                  "11月",
                  "12月",
                ],
                days: [
                  "Sunday",
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                ],
                shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                toolbar: {
                  exportToSVG: "保存为SVG",
                  exportToPNG: "保存为PNG",
                  exportToCSV: "保存为CSV",
                  menu: "菜单",
                  selection: "选择",
                  selectionZoom: "选择缩放",
                  zoomIn: "放大",
                  zoomOut: "缩小",
                  pan: "选择拖曳",
                  reset: "重置缩放",
                },
              },
            },
          ],
        },
        plotOptions: {
          bar: {
            rangeBarGroupRows: true,
            horizontal: true,
            dataLabels: {
              hideOverflowingLabels: true,
            },
          },
        },
        tooltip: {
          enabled: true,
          x: {
            show: false,
            format: "MM月dd日",
            formatter: undefined,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            //var label = opts.w.globals.labels[opts.dataPointIndex]
            var a = moment(val[0]);
            var b = moment(val[1]);
            var diff = b.diff(a, "days");
            return diff + "天";
          },
          style: {
            colors: ["#f3f4f5", "#fff"],
          },
        },
        xaxis: {
          type: "datetime",
          labels: {
            datetimeUTC: false,
            datetimeFormatter: {
              year: "yyyy",
              month: "yyyy-MM",
              day: "MM-dd",
              hour: "HH:mm",
            },
          },
        },
        yaxis: {
          show: true,
        },
        grid: {
          row: {
            colors: ["#f3f4f5", "#fff"],
            opacity: 1,
          },
        },
        legend: {
          position: "top",
        },
      };

      ///////////////////////算法

      let series = [];

      this.RawData.forEach((item) => {
        let data = [];

        let serie = {};

        item.steps.forEach((step) => {
          if (!(step.startTime || step.actTime)) {
            return;
          }
          serie.name = item.project;

          data.push({
            x: item.project + "-" + step.stepName,
            y: [new Date(step.startTime).getTime(), new Date(step.actTime).getTime()],
          });
        });

        if (serie.name) {
          series.push({
            name: serie.name,
            data: data,
          });
        }
      });

      /////////////

      options.series = series;

      this.$nextTick(() => {
        var chart = new ApexCharts(document.querySelector("#chart"), options);
        chart.render();
      });
    },

    //显示时间线
    async timelineShowClick(reverse = false) {
      if (reverse) {
        this.showAllYearData = !this.showAllYearData;
      }

      this.timelineShow = true;
      await this.refresh();
      let containerElement = document.querySelector("#chartcontainer");
      if (containerElement) {
        containerElement.innerHTML = '<div id="chart"></div>';
      }

      var options = {
        series: [
          {
            name: "新增数",
            color: "#2b8a3e",
            data: [],
          },
          {
            name: "未完成",
            data: [],
          },
          {
            name: "已完成",
            data: [],
          },
          {
            name: "已逾期",
            data: [],
          },
        ],
        chart: {
          type: "bar",
          height: 600,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: undefined,
        },
        yaxis: {
          title: {
            text: "任务数",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "个项目";
            },
          },
        },
      };

      let thisweek = dayjs().week();
      //console.log(thisweek)
      let catlog = [];
      for (let index = 1; index <= thisweek; index++) {
        options.series[0].data.push(0);
        options.series[1].data.push(0);
        options.series[2].data.push(0);
        options.series[3].data.push(0);
        catlog.push("第" + index + "周");
      }

      this.RawData.forEach((element) => {
        //console.log(element)
        element.steps.forEach((step) => {
          let startweek = moment(step.startTime).week();
          if (startweek <= thisweek) options.series[0].data[startweek - 1]++;

          if (step.planTime) {
            if (step.actTime) {
              let endweek = moment(step.actTime).week();

              if (endweek <= thisweek) options.series[2].data[endweek - 1]++;

              if (dayjs(step.actTime) > dayjs(step.planTime)) {
                let endweek = moment(step.actTime).week();
                for (let i = startweek; i <= endweek - 1; i++) {
                  if (i <= thisweek) options.series[3].data[i - 1]++;
                }
              }
            } else {
              if (dayjs() < dayjs(step.planTime).add(1, "day")) {
                let endweek = moment(step.planTime).week();
                for (let i = startweek; i <= endweek; i++) {
                  if (i <= thisweek) options.series[1].data[i - 1]++;
                }
              } else {
                let endweek = moment().week();
                for (let i = startweek; i <= endweek; i++) {
                  if (i <= thisweek) options.series[3].data[i - 1]++;
                }
              }
            }
          }
        });
      });

      if (this.showAllYearData) {
        if (thisweek > 4) {
          catlog = [
            catlog[catlog.length - 4],
            catlog[catlog.length - 3],
            catlog[catlog.length - 2],
            catlog[catlog.length - 1],
          ];
          options.series[0].data = [
            options.series[0].data[options.series[0].data.length - 4],
            options.series[0].data[options.series[0].data.length - 3],
            options.series[0].data[options.series[0].data.length - 2],
            options.series[0].data[options.series[0].data.length - 1],
          ];
          options.series[1].data = [
            options.series[1].data[options.series[1].data.length - 4],
            options.series[1].data[options.series[1].data.length - 3],
            options.series[1].data[options.series[1].data.length - 2],
            options.series[1].data[options.series[1].data.length - 1],
          ];
          options.series[2].data = [
            options.series[2].data[options.series[2].data.length - 4],
            options.series[2].data[options.series[2].data.length - 3],
            options.series[2].data[options.series[2].data.length - 2],
            options.series[2].data[options.series[2].data.length - 1],
          ];
          options.series[3].data = [
            options.series[3].data[options.series[3].data.length - 4],
            options.series[3].data[options.series[3].data.length - 3],
            options.series[3].data[options.series[3].data.length - 2],
            options.series[3].data[options.series[3].data.length - 1],
          ];
        }
      }
      options.xaxis.categories = catlog;

      this.$nextTick(() => {
        var chart = new ApexCharts(document.querySelector("#chart"), options);
        chart.render();
      });
    },

    //添加产品引用
    async addproductref() {
      this.selectModel = true;
    },

    async removeproductRef(item) {
      this.FormData.ProductRef = this.FormData.ProductRef.filter((i) => i != item);
    },

    //产品引用预览
    productpreviewclick(model) {
      let id = this.AllProductModels.find((item) => item.item == model);

      if (!id) {
        Swal.fire({
          icon: "warning",
          title: "该产品已被删除",
          showConfirmButton: false,
          timer: 3000,
        });
      }

      id = id.id;

      GetProductByid([id]).then((res) => {
        //console.log(res)
        this.previewDatas = res.data;
        this.previewShow = true;
      });
    },

    //
    productspreviewclick(row) {
      let models = row.productRef;

      if (!models.length) {
        Swal.fire({
          icon: "warning",
          title: "无关联产品",
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }

      let id = models.map((item) => {
        //console.log(item)
        let res = this.AllProductModels.find((product) => product.item == item);
        if (!res) {
          return;
        }
        return res.id;
      });

      id = id.filter((n) => n);

      console.log(id);

      GetProductByid(id).then((res) => {
        this.previewDatas = res.data;
        this.previewShow = true;
      });
    },
    //分割字符串
    splitStr(str) {
      if (!str) {
        return ["/"];
      } else {
        //console.log(str);
        return str.split("/");
      }
    },

    //导出
    async exportClick() {
      const $table = this.$refs.xTable;

      Swal.fire({
        title: "导出中...",
        html: "请稍候...",
        allowEscapeKey: false,
        allowOutsideClick: false,
      });
      Swal.showLoading();

      await delay(3000);

      Swal.close();

      $table.exportData({
        filename: dayjs().format("YYYY-MM-DD HH:mm:ss") + "导出文件",
        type: "csv",
      });
    },

    //上传图片附件
    async UploadPicture(file) {
      try {
        Swal.fire({
          title: "上传中...",
          html: "请稍候...",
          allowEscapeKey: false,
          allowOutsideClick: false,
        });
        Swal.showLoading();
        // object表示上传到OSS的文件名称。
        // file表示浏览器中需要上传的文件，支持HTML5 file和Blob类型。
        const r1 = await client.put(
          "ProductManagerProcess/" +
            Math.random().toString(36).substr(2) +
            file.file.name,
          file.file
        );
        Swal.close();
        if (r1.url === null) {
          return;
        }

        this.FormData.Pictures.push({
          FileName: file.file.name,
          FileUrl: r1.url,
        });
      } catch (e) {
        console.error("error: %j", e);
      }
    },

    //浏览图片
    imgViewClick(item) {
      //this.$alert(item);
      if (!item.pictures.length) {
        Swal.fire({
          icon: "warning",
          title: "无图片",
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }

      this.$viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: 0,
        },
        images: item.pictures.map((item) => item.FileUrl),
      });
    },

    ///FromData对象
    FormDataObj() {
      return {
        Id: undefined,
        CustomerID: "",
        BikeID: "",
        Model: "",
        Project: "",
        Project_Desription: "",
        ProjectType: "",
        Steps: [],
        DevProcess: "",
        Remark: "",
        Head: "",
        BusHead: "",
        Follower: "",
        Confirmer: "",
        Status: "进行中",
        ProductRef: [],
        Pictures: [],
      };
    },
  },
  mounted() {
    this.Role = getRole();
    this.refresh();
    GetUser().then((res) => {
      this.Users = res.data;
    });
    GetAllProductModels().then((res) => {
      this.AllProductModels = res.data;
    });
  },
};
</script>

<style>
.el-overlay {
  z-index: 999 !important;
}

.inputtitle {
  line-height: 10px;
}

.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}

.Steps {
  padding: 10px 0;
  background: #ededed;
}

.progresstable {
  font-size: 0.6rem;
}

.mytable-style.vxe-table .vxe-body--column.col-gray {
  background-color: #e9ecef;
  color: black;
}

.mytable-style.vxe-table .vxe-body--column.col-green {
  background-color: #d3f9d8;
  color: black;
}

.menuDiv {
  margin: 20px auto;
  height: 80px;
  background-color: #e9ecef;
  width: 600px;
  color: #555;
  cursor: pointer;
}

.menuDiv:hover {
  background-color: #3071b9;
  color: #fff;
}

.vxe-table--render-default {
  font-family: unset !important;
}

.vxe-cell--filter {
  font-size: 10px;
}
</style>
